import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "@/components";
import { Close } from "@/icons";
import "./CardInfoDoctorModalHeader.scss";
import { PropsWithChildren, ReactNode } from "react";

type CardInfoDoctorModalHeaderProps = PropsWithChildren<{
  closeButton?: string;
  onCloseClick?: () => void;
  children?: ReactNode;
}>;

export const CardInfoDoctorModalHeader = ({
  closeButton = "Chiudi",
  onCloseClick,
  children,
}: CardInfoDoctorModalHeaderProps) => {
  return (
    <header className="ui-card-info-modal-header bg-white">
      <Dialog.Close asChild className="ui-card-info-modal-header-close">
        <Button
          size="4"
          variant={"closeModal"}
          aria-label="Chiudi modale"
          onClick={(e: any) => {
            e.stopPropagation();
            onCloseClick?.();
          }}
        >
          <span className="ui-card-info-modal-header-close-label">
            {closeButton}
          </span>
          <Close className="ml-x8" width={24} height={24} />
        </Button>
      </Dialog.Close>
      <Dialog.Title className="fs-6 md-fs-custom text-slate-20 fw-bold header-title-with-children">
        {children}
      </Dialog.Title>
    </header>
  );
};
